import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import {
    autoinject,
    bind,
    Enums,
    FormStore,
    inject,
    Input,
    Loader,
    Modal,
    ModalHandle,
    Nullable,
    TasksStore,
} from 'Mri.Web.Common';
import * as React from 'react';
import { Button, Form, FormGroup } from 'reactstrap';
import { ActiveDisplay } from './ActiveDisplay';
import { DisplaysStore } from './DisplaysStore';

export interface ICommentsModalProps {
    readonly display: ActiveDisplay;
    readonly modalHandle: ModalHandle;
}

@autoinject
@observer
export class CommentsModal extends React.Component<ICommentsModalProps> {
    public render() {
        const { display } = this.props;
        return (
            <Modal
                className="modal-md"
                title={`${display.serialNumber} Comments`}
                modalHandle={this.props.modalHandle}
                onOpened={this.loadAsync}
                btnClass="w-50"
                footer={this.footer}
                bodyClass="minh-200"
                footerClass="d-flex justify-content-center"
            >
                <Form>
                    <div className="row flex-items-center">
                        <div className="col-12">
                            {this.displayCommentsForm && (
                                <FormGroup color={this.displayCommentsForm.fields.comments.state}>
                                    <Input
                                        type="textarea"
                                        field={this.displayCommentsForm.fields.comments}
                                        className="minh-200"
                                        placeholder="Comments..."
                                    />
                                </FormGroup>
                            )}
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }

    @bind
    @action
    private async loadAsync() {
        const model: Nullable<Mri.Web.Internal.Controllers.Displays.DisplayCommentsModel> = {
            displaySerialNumber: this.props.display.serialNumber,
            comments: this.props.display.comments || '',
        };

        this.displayCommentsForm = new FormStore<Mri.Web.Internal.Controllers.Displays.DisplayCommentsModel>(model);
    }

    @bind
    @action
    private async submitAsync(event: React.FormEvent<HTMLButtonElement>) {
        if (!this.displayCommentsForm) throw new Error('Form does not exist');
        this.loading = true;
        event.preventDefault();
        this.displayCommentsForm.onSubmit();

        if (this.displayCommentsForm.validate()) {
            const task = this.tasksStore.startSessionTask('Update Comments For ' + this.props.display.serialNumber);

            try {
                await this.displaysStore.updateDisplayCommentsAsync(
                    this.props.display.serialNumber,
                    this.displayCommentsForm.values
                );

                task.complete();
                this.props.modalHandle.close();
            } catch (e: any) {
                task.error(e);
            } finally {
                this.loading = false;
            }
        } else {
            console.log('invalid');
        }
    }

    @computed
    private get footer() {
        return (
            <Button color="primary" onClick={this.submitAsync} disabled={this.loading}>
                <Loader loading={this.loading} showSpinner message="Updating Comments..." />
                {!this.loading && 'Update Comments'}
            </Button>
        );
    }

    @observable
    private loading = false;
    @observable
    private displayCommentsForm?: FormStore<Mri.Web.Internal.Controllers.Displays.DisplayCommentsModel>;
    @inject
    private displaysStore!: DisplaysStore;
    @inject
    private tasksStore!: TasksStore;
}
